import { FC, SVGAttributes } from 'react';

const GiftCard: FC<SVGAttributes<SVGElement>> = (props) => {
    return (
        <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
                d="M1.5 10.3C1.5 7.3306 1.5 5.84485 2.42295 4.92295C3.34485 4 4.8306 4 7.8 4H16.2C19.1694 4 20.6551 4 21.577 4.92295C22.5 5.84485 22.5 7.3306 22.5 10.3V14.5C22.5 17.4694 22.5 18.9551 21.577 19.877C20.6551 20.8 19.1694 20.8 16.2 20.8H7.8C4.8306 20.8 3.34485 20.8 2.42295 19.877C1.5 18.9551 1.5 17.4694 1.5 14.5V10.3Z"
                stroke="currentColor"
                strokeWidth="1.5"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M22.5 12.5C22.5 12.5 8.91996 12.5 1.5 12.5M12 4V20.5M12.95 12.5C12.95 13.5078 13.3504 14.4744 14.063 15.187C14.7756 15.8996 15.7422 16.3 16.75 16.3M11.05 12.5C11.05 13.5078 10.6496 14.4744 9.93701 15.187C9.22437 15.8996 8.25782 16.3 7.25 16.3"
                stroke="currentColor"
                strokeWidth="1.5"
                strokeLinecap="round"
            />
            <path
                d="M11.9994 10.6344C12 9.94653 12.2302 9.27855 12.6536 8.73643C13.0769 8.1943 13.6692 7.80908 14.3364 7.64188C15.8593 7.26188 17.2396 8.64128 16.8587 10.1651C16.6915 10.8323 16.3063 11.4246 15.7641 11.848C15.222 12.2713 14.554 12.5015 13.8662 12.5021H11.9994M11.9994 10.6344V12.5021M11.9994 10.6344C11.9989 9.94653 11.7687 9.27855 11.3453 8.73643C10.9219 8.1943 10.3297 7.80908 9.66244 7.64188C8.13959 7.26188 6.75924 8.64128 7.14019 10.1651C7.30739 10.8323 7.69261 11.4246 8.23473 11.848C8.77685 12.2713 9.44483 12.5015 10.1327 12.5021H11.9994"
                stroke="currentColor"
                strokeWidth="1.5"
            />
        </svg>
    );
};

export default GiftCard;
